/** @format — Truncated assistant markdown with View more / Show less */

import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import { chatRemarkPlugins, chatTextWrapClassName, chatTextWrapStyle } from "../../../utils/chatHelpers";

const PREVIEW_MAX_HEIGHT = "8.5rem";

export default function CollapsibleAgentText({
  text,
  components,
  minCharsToCollapse = 280,
}) {
  const [expanded, setExpanded] = useState(false);
  const shouldCollapse =
    typeof text === "string" && text.trim().length > minCharsToCollapse;

  if (!shouldCollapse) {
    return (
      <ReactMarkdown remarkPlugins={chatRemarkPlugins} components={components}>{text}</ReactMarkdown>
    );
  }

  return (
    <div className={`min-w-0 max-w-full ${chatTextWrapClassName}`} style={chatTextWrapStyle}>
      <div
        className={
          expanded
            ? ""
            : "relative max-h-[8.5rem] overflow-hidden"
        }
        style={expanded ? undefined : { maxHeight: PREVIEW_MAX_HEIGHT }}
      >
        <ReactMarkdown remarkPlugins={chatRemarkPlugins} components={components}>{text}</ReactMarkdown>
        {!expanded ? (
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-14 bg-gradient-to-t from-white via-white/90 to-transparent"
            aria-hidden
          />
        ) : null}
      </div>
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="mt-2 text-[13px] font-medium text-[#2746EB] hover:underline focus:outline-none"
      >
        {expanded ? "Show less" : "View more"}
      </button>
    </div>
  );
}
